(function () {
  const stickyBar = document.createElement('div');
  stickyBar.id = 'sticky-atc-bar';
  stickyBar.innerHTML = `
    <div class="sticky-atc-inner">
      <div class="sticky-atc-title"></div>
      <div class="sticky-atc-actions">
        <button class="sticky-atc-btn sticky-buy-now">Buy Now</button>
        <button class="sticky-atc-btn sticky-add-cart">Add to Cart</button>
      </div>
    </div>
  `;
  document.body.appendChild(stickyBar);

  const originalATC = document.querySelector('.product-form__buttons');
  const productTitle = document.querySelector('.product__title h1, h1.product__title');

  if (!originalATC) return;

  // Title set
  if (productTitle) {
    stickyBar.querySelector('.sticky-atc-title').textContent = productTitle.textContent.trim();
  }

  // Scroll logic
  window.addEventListener('scroll', function () {
    const rect = originalATC.getBoundingClientRect();
    if (rect.bottom < 0) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  });

  // Add to Cart click
  stickyBar.querySelector('.sticky-add-cart').addEventListener('click', function () {
    const originalATCBtn = originalATC.querySelector('[name="add"]');
    if (originalATCBtn) originalATCBtn.click();
  });

  // Buy Now click
  stickyBar.querySelector('.sticky-buy-now').addEventListener('click', function () {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]').value;
    window.location.href = `/checkout?variant=${variantId}&quantity=1`;
  });
})();